export default "__VITE_ASSET__5d7eaf53__"